import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
  import ('@/containers/DefaultContainer')

// Views
const Dashboard = () =>
  import ('@/views/Dashboard')

// Views - Pages
const Page404 = () =>
  import ('@/views/pages/Page404')
const Page500 = () =>
  import ('@/views/pages/Page500')
const Login = () =>
  import ('@/views/pages/Login')

import Users from '@/views/users/router.js'
import Families from '@/views/families/router.js'
import FamilyMembers from '@/views/familymembers/router.js'
import Activities from '@/views/activities/router.js'
import SubActivities from '@/views/subactivities/router.js'
import FamilyTypes from '@/views/familymembertypes/router.js'
import ParticipantHistory from '@/views/history/router.js'
import Redcases from '@/views/redcases/router.js'
import TheSettings from '@/views/settings/router.js'
import Registrations from '@/views/registrations/router.js'
import MembershipTypes from '@/views/membershiptypes/router.js'
import Regions from '@/views/regions/router.js'
import Zipcodes from '@/views/zipcodes/router.js'
import Distribution from '@/views/distribution/router.js'
import Fees from '@/views/fees/router.js'
import ActivityYear from '@/views/activity_years/router.js'
import EmailTemplates from '@/views/emailtemplates/router.js'
import EmailCampaigns from '@/views/emailcampaigns/router.js'

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '*',
      component: Page404
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        auth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        Users,
        Families,
        FamilyMembers,
        Activities,
        SubActivities,
        FamilyTypes,
        ParticipantHistory,
        Redcases,
        Registrations,
        MembershipTypes,
        TheSettings,
        Regions,
        Zipcodes,
        Distribution,
        Fees,
        ActivityYear,
        EmailTemplates,
        EmailCampaigns
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      }]
    },

  ]
})
